export { epic } from './epic'


// WEBPACK FOOTER //
// ./src/scripts/app/modules/gates/index.js